import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";

import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import { bindActionCreators } from 'redux';
import Alert from '../../Components/Alert';
import { updateAdmin } from '../../store/user/actions';
import { userPermissions, loaderstyle } from '../../config';
import Checkbox from '../../Components/Checkbox';

class EditAdmin extends Component {
  constructor(props) {
    super();

    const admin = props.admins.find(a => a._id === props.match.params.adminID);
    let permissions = [];
    
    if (admin) {
      permissions = admin.permissions;
    }

    this.state = {
      admin,
      updated: false,
      permissions: permissions
    }
  }

  handlePermissionChange = (e) => {
    const currentPermissions = Object.assign([], this.state.permissions);
    if (e.target.checked) {
      // add permission
      currentPermissions.push(e.target.name);
    } else {
      // remove permission
      currentPermissions.splice(currentPermissions.indexOf(e.target.name), 1);
    }

    this.setState({permissions: currentPermissions});
  }

  updateAdmin = (e) => {
    e && e.preventDefault();

    this.props.updateAdmin(this.state.admin, { permissions: this.state.permissions }, this.updateSuccess);
  }

  updateSuccess = () => {
    this.props.history.replace('/admins', { adminUpdated: true, email: this.state.admin.email });
  }

  render() {
    const { admin } = this.state;
    let color = 'red';
    let msg = this.props.error;

    if (!admin) {
      this.props.history.replace('/admins');
      return null;
    }

    return (
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Edit Admin</h1>
            </div>
          </div>
          <hr/>
          <Alert color={color} msg={msg} />
          <LoadingOverlay
            active={this.props.loading}
            text="Loading..."
            spinner
            styles={loaderstyle}
          >
            <form className="addAdminForm" onSubmit={this.updateAdmin}>
              <div className="form-field">
                <h5 className="label">Full Name</h5>
                <input type="text" name="name" onChange={this.handleFieldChange} disabled value={admin.name} />
              </div>
              <div className="form-field">
                <h5 className="label">Email Address</h5>
                <input type="email" name="email" onChange={this.handleFieldChange} disabled value={admin.email} />
              </div>
              <div className="form-field">
                <h5 className="label">Roles</h5>
                <Checkbox name={userPermissions.viewBookings} text={'View Bookings'} defaultChecked={this.state.permissions.includes(userPermissions.viewBookings)} onChange={this.handlePermissionChange} />
                <Checkbox name={userPermissions.viewCustomers} text={'View Customers'} defaultChecked={this.state.permissions.includes(userPermissions.viewCustomers)} onChange={this.handlePermissionChange} />
                <Checkbox name={userPermissions.viewSettings} text={'View Settings'} defaultChecked={this.state.permissions.includes(userPermissions.viewSettings)} onChange={this.handlePermissionChange} />
              </div>
              <hr/>
              <Btn className="btn submit">update admin</Btn>
            </form>
          </LoadingOverlay>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  admins: state.user.admins,
  error: state.user.error,
  loading: state.user.loading,
})

const mapDispatchToProps = dispatch => ({
  updateAdmin: bindActionCreators(updateAdmin, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditAdmin));